import { type FC, type HTMLAttributes, type PropsWithChildren } from 'react';

import { getClassNames } from '@eneco/sparky/util/css';

import { animatedBoxStyle } from './AnimateHeightBox.css';

type AnimatedBoxProps = HTMLAttributes<HTMLDivElement>;

export const AnimatedBox: FC<AnimatedBoxProps> = ({ className, ...props }) => (
  <div className={getClassNames(animatedBoxStyle, className)} {...props} />
);

interface AnimateheightboxProps extends PropsWithChildren {
  newHeight?: number;
  isAnimating?: boolean;
}

export const AnimateHeightBox: FC<AnimateheightboxProps> = ({ children, newHeight, isAnimating }) => (
  <AnimatedBox style={isAnimating ? { height: newHeight } : { height: 'auto' }}>{children}</AnimatedBox>
);
